export default __webpack_public_path__ + "static/media/GuyAnimation17.ab26ce5f.svg";